import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ICONS } from '../../../../constants/constants';
import {
  PASSWORD_STRENGTH_KEY,
  PASSWORD_STRENGTH_SCORE,
} from '../../../../constants/constants';
import { passwordStrengthValidator } from '../../../../modules/shared/validators/password.validator';

@Component({
  selector: 'app-input-wrapper',
  templateUrl: './input-wrapper.component.html',
  styleUrls: ['./input-wrapper.component.scss'],
})
export class InputWrapperComponent {
  protected readonly ICONS = ICONS;

  @Input() public fc: UntypedFormControl;
  @Input() public label: string;
  @Input() public for: string;
  @Input() public hasPasswordValidation: boolean = false;
  @Input() public type:
    | 'text'
    | 'email'
    | 'password'
    | 'datetime-local'
    | 'tel' = 'text';
  @Input() public showPassword: boolean = false;
  @Input() public note: string;
  @Input() public min: string = '';
  @Input() public isEmail: boolean = false;
  @Input() public isPassword: boolean = false;

  @Output()
  toggleShowPassword: EventEmitter<void> = new EventEmitter();

  get applyError(): boolean {
    return (this.fc?.errors && this.hasHadInteraction) || false;
  }

  get hasHadInteraction(): boolean {
    return this.fc?.touched || this.fc.value;
  }

  get showPasswordError(): boolean {
    if (this.hasPasswordValidation && this.hasHadInteraction) {
      return this.getPasswordStrengthScore() < PASSWORD_STRENGTH_SCORE.SUCCESS;
    }

    return false;
  }

  get passwordValidationErrorType(): string | null {
    if (this.hasPasswordValidation && this.hasHadInteraction) {
      const score = this.getPasswordStrengthScore();

      if (score >= PASSWORD_STRENGTH_SCORE.SUCCESS) {
        return null;
      }

      return score > PASSWORD_STRENGTH_SCORE.ERROR ? 'warning' : 'error';
    }

    return null;
  }

  get passwordValidationError(): string | null {
    const errorType = this.passwordValidationErrorType;

    if (errorType) {
      return `password_validation_${errorType}`;
    }

    return null;
  }

  getPasswordStrengthScore(): number {
    return passwordStrengthValidator(true)(this.fc)?.[PASSWORD_STRENGTH_KEY];
  }

  get passwordStrengthCssClass(): string | null {
    const errorType = this.passwordValidationErrorType;

    if (errorType) {
      return `input-wrapper__password--${errorType}`;
    }

    return null;
  }
}
